import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { SessionKey } from "@shared/clickar-constants";
import { PartnerDTO } from "@shared/model/partnerDTO";
import { StorageManagerService } from "@shared/services/storage/storage-manager.service";
import { TemplateService } from "@shared/services/template/template.service";
import { ClickarUtilsService } from "@shared/services/utils/clickar-utils.service";
import { OwlOptions } from "ngx-owl-carousel-o";
@Component({
	selector: "app-partner",
	templateUrl: "./partner.component.html",
	styleUrl: "./partner.component.css",
	standalone: false
})
export class PartnerComponent implements OnInit {
	partners: PartnerDTO[];
	partner: PartnerDTO;
	slideSize = 0;
	offset = 2;
	size: number[] = [];
	customOptions: OwlOptions = {
		loop: true,
		mouseDrag: true,
		touchDrag: false,
		pullDrag: false,
		dots: true,
		navSpeed: 300,
		nav: false,
		autoplay: true,
		responsive: {
			0: {
				items: 1 // on small screens, show 1 image
			},
			600: {
				items: 4 // on medium screens, show 2 images
			},
			1000: {
				items: 6 // on large screens, show 4 images
			}
		}
	};

	constructor(
		private templateService: TemplateService,
		public utils: ClickarUtilsService,
		private activatedRoute: ActivatedRoute,
		private storageService: StorageManagerService,
		private translate: TranslateService
	) { }

	ngOnInit() {
		// let market = this.translate.getCurrentLang();
		const localizedCountry = this.storageService.getSessionItem(
			SessionKey.GEOLOCATION_MARKET,
			this.translate.getCurrentLang().slice(3)
		);

		this.templateService
			.getPartnersOpenUsingGET(localizedCountry.toUpperCase())
			.subscribe(value => {
				this.partners = value;
				this.size = [];
				if (this.partners.length == 0) {
					this.slideSize = 0;
				} else if (this.partners.length < this.offset) {
					this.slideSize = 1;
					this.size.push(1);
				} else {
					this.slideSize = Math.ceil(
						this.partners.length / this.offset
					);
					for (let i = 0; i < this.slideSize; i++) {
						this.size.push(i);
					}
				}

				this.activatedRoute.params.subscribe(value => {
					const idTemplate = value["idTemplate"];

					if (idTemplate) {
						this.partner = this.partners.filter(
							value1 => value1.idTemplate == idTemplate
						)[0];
					}
				});
			});
	}

	selectedPartner(partner: PartnerDTO) {
		this.partner = partner;
		window.scrollTo(0, 0);
	}
}
